import { styled } from 'styled-components';

const PageStyled = styled.div`
  overflow: auto;
  height: 100vh;
  display: flex;
`;

export default PageStyled;
